<template>
  <!-- mover esto a la carpeta de signos vitales -->
  <div>
    <SaveSignosVitales />

    <b-card>
      <b-row class="mt-2">
        <b-col md="4">
          <b-form-group>
            <label>Buscar:</label>
            <b-form-input
              v-model="consultarcit"
              placeholder="Buscar por nombres, apellidos, especialidad o cedula"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>

        <!-- <b-col md="2">
          <b-form-group>
            <label>Establecimiento:</label>
            <v-select
              id="establecimiento"
              v-model="establecimiento"
              :options="establecimientos"
              :reduce="option => option.value"
              label="text"
            />
          </b-form-group>
        </b-col> -->

        <b-col md="2">
          <b-form-group>
            <label for="fecha-desde">Fecha (desde): </label>
            <flat-pickr
              v-model="fecha_desde"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>

        <b-col md="2">
          <b-form-group>
            <label for="fecha-hasta">Fecha (hasta): </label>
            <flat-pickr
              v-model="fecha_hasta"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>

        <b-col  md="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <b-button variant="primary" @click="buscarSignos">
            <font-awesome-icon icon="magnifying-glass" style="color: white;"/> 
            <span style="color: white;">buscar</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
    >
      <b-card class="principal">
        <b-col
          cols="12"
          class="pr-0 pl-0 mt-2"
        >
          <b-table
            v-if="items.length > 0"
            bordered
            ref="selectableTable"
            @row-selected="onRowSelected"
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
          >

            
            <template #cell(acciones)="data">
              <div class="d-flex justify-content-end">
                <b-button
                  v-if="data.item.tokenSignosvital"
                  variant="info"
                  size="sm"
                  @click="viewItem(data.item.tokenSignosvital, data.item)"
                >
                  <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                </b-button>
                <b-button 
                  variant="success" 
                  size="sm" 
                  @click="openSignosModal(data.item)"
                >
                  <font-awesome-icon icon="heart" style="color: white;" />
                </b-button>
              </div>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col
          cols="12"
          class="mb-2"
        >
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPageModificado"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>

    <SignoModalViewDetails :tokenSignos.sync="tokenSignosView" />

  </div>
</template>


<script>
import { BootstrapVue } from 'bootstrap-vue';
import SignoModalViewDetails from '@/views/signosVitales/SignoModalViewDetails.vue';
import { SaveSignosVitales } from '@/views/signosVitales/components';

import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import actions from '@/assets/utils/utils'
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import flatPickr from "vue-flatpickr-component";
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import 'flatpickr/dist/flatpickr.css';

library.add(faHeart);

export default {

  name: 'ConsultarSignosVitales',
        
  components: {
    ...BootstrapVue.components,
    SignoModalViewDetails,
    SaveSignosVitales,
    flatPickr,
    vSelect,
  },

  data() {
      
    return {
      itemSeleccionado : null,
      edadPaciente : null,
      fechaCita : null,
      tokenSignosView:null,

      userRoles: ['citamedica_editar_cita', 'citamedica_ver_cita'],
      filtroEstado: null, // Estado actual del filtro
      mostrarLoader: false,
      login_user: '',
      consultarcit:null,
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      currentPageModificado: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      doctor:null,
      establecimiento:null,
      establecimientos:[],
      fecha_desde: '',
      fecha_hasta: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
      { key: 'identificacion',       label: 'Identificacion Paciente',       sortable: true, thClass: 'text-center', width: '150px' },
         { key: 'idDoctor',       label: 'Doctor',       sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'idPaciente',     label: 'Paciente',     sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'usuarioCreador', label: 'Usuario',      sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'especialidad',   label: 'Especialidad', sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'fechaCita',      label: 'Fecha',        sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'horaCita',       label: 'Hora',         sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'acciones',       label: 'acciones',     sortable: true, thClass: 'text-center', tdClass: 'text-right', width: '150px' },            

      ],
      listaAcciones: [],
      token_usuario: '',
      items: [],
      descripcion: '',
      opsDoctor: [],
      codG: [
                '0000000001', '0000000013', '0000000012','0000000017', '0000000018', '0000000019', '0000000020'
            ],
    }
  },

  created() {
    this.setToken();
    this.fetchEstablecimientos();
    this.fetchConsultarSignosVital();
  },

  mounted() {
    actions.setearTitulo('Signos Vitales')
  },


  methods: {

    obtenerFechaHoy() {
      const fecha = new Date();
      const anio = fecha.getFullYear();
      const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Sumar 1 al mes porque empieza desde 0
      const dia = String(fecha.getDate()).padStart(2, '0');
      return `${anio}-${mes}-${dia}`;
    },

    formatDateToISO(dateString) {
      if (!dateString) return '';
      const [day, month, year] = String(dateString).split('/');
      if (!day || !month || !year) return dateString;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    async viewItem(tokenSignosvital, item) {
      this.fechaCita = item.fechaCita
      this.edadPaciente = item.edadPaciente
      this.itemSeleccionado = item
      this.tokenSignosView = tokenSignosvital;
    },

    openSignosModal(item) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          signosVitales: item.tokenCita,
        },
      });
    },

    cambiarPagina(value) {
      const paginaActual = value;
      const limiteSuperior = value * this.perPage;
      const limiteInferior = (value - 1) * this.perPage;
      const desde = limiteInferior;
      const hasta = limiteSuperior;
      this.fetchConsultarSignosVital(this.consultarcit ? this.consultarcit : '', this.establecimiento ? this.establecimiento : '', this.fecha_desde,  this.fecha_hasta, paginaActual, desde, hasta);
    },
    async fetchConsultarSignosVital(nombre = '', establecimiento = '', fechaDesde = '', fechaHasta = '', pagina_actual = 1, desde = 0, hasta = 15){
      
      let user = JSON.parse(localStorage.getItem('detalleusuario'))
        
        
      let estab = user.establecimiento ? user.establecimiento.id : ""
      user.roles.forEach(i => {
        if (this.codG.includes(i.codigo)) {
            
          this.establecimiento = '0'
        }
        else
        {this.establecimiento = estab}
      });
      
      
      const query = ` 
        query qrAllCitasSignos(
          $nombre: String,
          $fechaDesde: String,
          $fechaHasta: String,
          $establecimiento: String,
          $page: Int,
          $pageSize: Int
        ) {
          allCitas(
            nombre: $nombre,
            fechaDesde: $fechaDesde,
            fechaHasta: $fechaHasta,
            establecimiento: $establecimiento,
            page: $page,
            pageSize: $pageSize
          ) {
            total
            status
            message
            cita {
              id
              token
              fechaCita
              horaCita
              estadoSignosvital
              estadoActual
              signosvitalSet {
                token
                usuarioCreador {
                  username
                }
              }
              paciente {
                id
                persona {
                  primerNombre
                  primerApellido
                  identificacion
                  fechaNacimiento
                }
              }
              doctor {
                id
                idPersona {
                  primerNombre
                  primerApellido
                  identificacion
                }
                especialidad {
                  descripcion
                }
              }
            }
          }
        }
      `;

      const varConsulta = {
        nombre: nombre,
        fechaDesde: this.formatDateToISO(fechaDesde),
        fechaHasta: this.formatDateToISO(fechaHasta),
        establecimiento: this.establecimiento,
        page: pagina_actual,
        pageSize: this.perPage
      };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables: varConsulta });
        if (response.status === 200) {
          if (response.data.data.allCitas.status === 'success') {
            const citas = response.data.data.allCitas.cita || [];

            const citasConSignos = citas.map(item => {
              const signos = item.signosvitalSet?.[0] || null;
              const edadPaciente = this.calcularEdad(item.paciente.persona.fechaNacimiento);

              return {
                id: item.id,
                idCita: item.id,
                tokenCita: item.token,
                tokenSignosvital: signos?.token || null,
                idDoctor: `${item.doctor.idPersona.primerApellido} ${item.doctor.idPersona.primerNombre}`,
                fechaCita: item.fechaCita,
                horaCita: item.horaCita,
                identificacion: item.paciente.persona.identificacion,
                idPaciente: `${item.paciente.persona.primerApellido} ${item.paciente.persona.primerNombre}`,
                usuarioCreador: signos?.usuarioCreador?.username || 'No disponible',
                especialidad: item.doctor.especialidad.descripcion,
                edadPaciente,
                signosHoy: this.obtenerFechaHoy() === item.fechaCita,
                estadoSignosVitales: Number(item.estadoSignosvital || 0),
                estadoCita: item.estadoActual,
              };
            });

            this.items = citasConSignos.filter(item => item.estadoCita !== '0');
            this.totalRows = response.data.data.allCitas.total;
            this.currentPage = 1;
            this.currentPageModificado = pagina_actual;

          }

        }
      } catch (error) {
        console.error("Error fetching signos vitales:", error);
      }

    },
    calcularEdad(fechaNacimiento) {
    
  
    const fechaNacimientoDate = new Date(fechaNacimiento);
    
    const hoy = new Date();
    
    let edad = hoy.getFullYear() - fechaNacimientoDate.getFullYear();
    
    const mesDiferencia = hoy.getMonth() - fechaNacimientoDate.getMonth();
    if (mesDiferencia < 0 || (mesDiferencia === 0 && hoy.getDate() < fechaNacimientoDate.getDate())) {
      edad--;
    }
    // if(edad > 0) { edad = `${edad} años` } else { edad = "menor a 1 año"}
    
    return edad;
  },
    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem('permisos');
      return permisosUsuario.indexOf(permission) !== -1;
    },
      
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value    : item.id,
          text     : item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },
      
    onRowSelected(items) {
      this.selected = items
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },

    redirectToAtencionMedica(idCit) {
      this.$router.push({ name: 'crear_atencion_medica', params:{ id:idCit } });
    },

    removeItemid(idCit) {
      const mesa = this.fetchRemoveCita(idCit);
    },

    async fetchRemoveCita(idCit) {
      this.$swal({
        title: 'Estas seguro de eliminar Cita?',
        text: "No seras capaz de revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Borrar esto!',
        cancelButtonText: 'No, cancelar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const argRmCit = {
              id: idCit,
            }
            const response = await axios.post(rutas.axios + 'api', {
              query: `mutation
                  removerCita ( $id: String!){
                  removerCita( idCit:$id){
                    cita {
                      token
                    }
                    status,
                    message
                  }
              } `,
              variables: argRmCit
            });

            if (response.status === 200) {
              if (response.data.data.removerCita.status === 'success') {
                if (response.status === 200) {
                  this.$swal({
                    title: 'Borrado!',
                    text: 'Tu registro ha sido eliminado',
                    icon: 'success',
                    confirmButtonColor: '#3085d6'
                  }).then((result) => {
                    // This will only run when the user presses "OK" on the "Deleted!" modal
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
                this.$router.push({ name: 'consultar_citas' })
                  .catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                      console.error(err);
                    }
                  });
              } else {
                this.$swal({
                  title: 'Error',
                  text: response.data.data.removerCita.message,
                  icon: 'error',
                  confirmButtonColor: '#089599',
                })
              }
            }
          } catch (err) {
            console.log(err);
            return 'Error al eliminar doctor';
          }
        } else {
          // User clicked the cancel button
          this.$swal({
            title: 'Cancelado',
            text: 'Your registro esta seguro :)',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          });
        }
      });
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },

    buscarSignos() {
      if (this.consultarcit) {
        this.fetchConsultarSignosVital(
          this.consultarcit, this.establecimiento,
          this.fecha_desde, this.fecha_hasta, 1, 0, 15
        );
      }else{
        this.fetchConsultarSignosVital(
          '', this.establecimiento,
          this.fecha_desde, this.fecha_hasta, 1, 0, 15
        );
      }
    },
  },

  watch: {
    '$route.query.signosVitales': {
      handler(newValue, oldValue) {
        if (oldValue && !newValue) {
          this.fetchConsultarSignosVital(
            this.consultarcit ? this.consultarcit : '',
            this.establecimiento ? this.establecimiento : '',
            this.fecha_desde,
            this.fecha_hasta,
            this.currentPageModificado || 1
          );
        }
      }
    }
  }
}
</script>
